import { Badge } from '@/components/ui/badge'

interface StatusBadgeProps {
  active: boolean
  activeLabel?: string
  inactiveLabel?: string
}

export function StatusBadge({
  active,
  activeLabel = 'Activo',
  inactiveLabel = 'Inactivo',
}: StatusBadgeProps) {
  return (
    <Badge variant={active ? 'success' : 'secondary'}>
      <span
        className={`h-1.5 w-1.5 rounded-full ${active ? 'bg-utility-success-500' : 'bg-fg-quinary'}`}
      />
      {active ? activeLabel : inactiveLabel}
    </Badge>
  )
}
